import { styled } from '@/stitches.config';

const SectionTitle = styled('h3', {
  paddingLeft: '$0',
});

export default SectionTitle;
